import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "root-order-state-button-wrapper" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.buttonList, (name, key) => {
            return (_openBlock(), _createElementBlock("button", {
                key: key,
                class: _normalizeClass(["button", _ctx.selectedButton(key)]),
                type: "button"
            }, _toDisplayString(_ctx.$t(name)), 3 /* TEXT, CLASS */));
        }), 128 /* KEYED_FRAGMENT */))
    ]));
}
